export const DEFAULT_NOVITA_API_URL =
  'https://www.onoranzefunebricloud.com/api/novita.json';
export const DEFAULT_NOVITA_EMBED_URL =
  'https://www.onoranzefunebricloud.com/novita/embed';

export const NOVITA_API_URL =
  process.env.NOVITA_API_URL || DEFAULT_NOVITA_API_URL;
export const NOVITA_EMBED_URL =
  process.env.NOVITA_EMBED_URL || DEFAULT_NOVITA_EMBED_URL;
export const NOVITA_EMBED_ALLOWED_ORIGINS = [
  'https://www.onoranzefunebricloud.com',
  'https://onoranzefunebricloud.com',
];

export const NOVITA_UNREAD_PAGE_SIZE = 100;
export const NOVITA_UNREAD_WINDOW_DAYS = 30;
export const NOVITA_UNREAD_STALE_TIME_MS = 60 * 60 * 1000;

export const NOVITA_DISMISSED_STORAGE_KEY = 'novita_overlay_dismissed_id';

export const NOVITA_EMBED_CHAT_MESSAGE_TYPE = 'ofc:open_chat';
export const NOVITA_EMBED_OPEN_URL_MESSAGE_TYPE = 'ofc:open_url';
export const NOVITA_EMBED_GO_BACK_MESSAGE_TYPE = 'ofc:go_back';
export const NOVITA_EMBED_VIEWED_MESSAGE_TYPE = 'ofc:novita_viewed';
export const NOVITA_EMBED_MARK_ALL_READ_MESSAGE_TYPE =
  'ofc:novita_mark_all_read';
export const NOVITA_EMBED_CHAT_MESSAGE_SOURCE = 'novita_embed';

export const NOVITA_SURFACE_OVERLAY = 'giotto_overlay';
export const NOVITA_SURFACE_PRIVATE_NAVBAR = 'giotto_private_navbar';
export const NOVITA_SURFACE_CANVAS_NAVBAR = 'giotto_canvas_navbar';

export const NOVITA_TRACK_EVENT_NAMES = {
  opened: 'novita_embed_opened',
  loaded: 'novita_embed_loaded',
};
